
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gFI7dFkvwTko8d7hX7Q0LiJdKqGgDwqvfsoGvejaK97QMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3_5y0NlXjLGYQwm_Xt5_455gF0ivov4jdhJY8wU7i6OxUMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchqlNsxiJQK7mjJkQHtAnv_457wctoZLM6zZR_45Sjhk6eIjoMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexWaqrjw1kpwmN7rb3Bg7yNDxxVnPo8gre6UP0YMa0JOIMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bvB0_7H44IrJJEukdfPQmYT9Cu7QoE5SRLT9Ktg4cEUMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexNin2JClD0xojJNaPee10tMVEnOK4dkWWN2bfRoi_45oEkMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_936h5Uiez97n0vMWgbfDRldF0fsIHkzPfnW4_W2tU0gNYMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexL4UFSIcbO_1I_45EKV_1hYuGjWfyhXgQ_45G1lxoXIyoa8IMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_938ZbHTBZ1rNXvbkaU_45poOLuBWsT5cPTn6oO02yJHGgjkMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexs_45qmlsxyxQ7Ci2LEss_45hqD4L1UD7dVHhr26YyxjJOdMMeta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexf7k7XwxkezWbFh9pw55VAVt0kljynHjqPCsTtE3cOd0Meta } from "/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexNin2JClD0xojJNaPee10tMVEnOK4dkWWN2bfRoi_45oEkMeta || {},
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexL4UFSIcbO_1I_45EKV_1hYuGjWfyhXgQ_45G1lxoXIyoa8IMeta || {},
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexs_45qmlsxyxQ7Ci2LEss_45hqD4L1UD7dVHhr26YyxjJOdMMeta || {},
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexf7k7XwxkezWbFh9pw55VAVt0kljynHjqPCsTtE3cOd0Meta || {},
    component: () => import("/codebuild/output/src1087482857/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]